"use client";
import { cn } from "@/lib";
import SplitButton from "./splitButton";
import { useModalStore } from "@/store/modalStore";
import HeaderNavigation from "./headerNavigation";
import { FlexBetween } from "./ui/flexBox";
import Logo from "./logo";
import { useSession } from "next-auth/react";
import UserDropdown from "./userDropdown";
import Link from "next/link";
import { routes } from "@/routes";
import { useTranslations } from "next-intl";

const AppHeader = () => {
  const t = useTranslations("header");
  const { setOpenModal } = useModalStore();
  const { data: session, status } = useSession();
  const isSessionLoading = status === "loading";
  const isLoggedIn = status === "authenticated";
  const handleOpenSideBar = () => {
    setOpenModal("sidebar");
  };

  return (
    <header className={cn("hidden items-center justify-between pt-10 md:flex")}>
      <Link
        id="app-header-logo"
        title={t("title")}
        href={routes.main.HOME.primaryPath}
      >
        <FlexBetween>
          <Logo width={70} height={70} />
          <span className="text-md font-bold text-white xl:text-lg">
            {t("title")}
          </span>
        </FlexBetween>
      </Link>
      <HeaderNavigation handleOpenSideBar={handleOpenSideBar} />

      {isSessionLoading ? (
        <div className="w-44"></div>
      ) : !isLoggedIn ? (
        <SplitButton />
      ) : (
        <UserDropdown phoneNumber={session.user.phoneNumber} />
      )}
    </header>
  );
};

export default AppHeader;
